// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_100w_animationWrapper__l_hh4"};